import moment from 'moment';
import { message } from 'antd';
import { getToDay } from '@/utils/date';
import { isAreaData } from '@/services/area';
import {
  getTransitFrequency,
} from '@/services/cost';

let [startDate] = getToDay();
const mergeAndStructure = (parentArray, childArray, key) => {
  return parentArray.map(parentItem => {
    const matchingItems = childArray.filter(childItem => childItem[key] === parentItem.originSite);
    return {
      ...parentItem,
      ...(matchingItems.length > 0 && { children: matchingItems }),
    };
  });
};

export default {
  namespace: 'transferFrequencyNew',
  state: {
    searchParams: {
      dayStartDate: moment(startDate).subtract(1, 'days').format('YYYY-MM-DD'),
      searchDate: moment(startDate).subtract(1, 'days').format('YYYY-MM-DD'),
      weekStartDate: moment(startDate).subtract(1, 'days').format('YYYY-MM'),
      areaProperty: [],
    },
    pageWeek: 1,
    pageSizeWeek: 50,
    totalWeek: 0,
    pageMonth: 1,
    pageSizeMonth: 50,
    totalMonth: 0,
    weekDatas: [],
    monthDatas: [],
    weekExportList: [],
    monthExportList: [],
    onSearch: false,
    transportLineType: '',
    weekType: '',
    exportVisible: false,
    access: {
      isHead: false,
      isArea: false,
      isCenter: true,
      code: '',
    },
    lineMonthSelectType: 'day',
  },

  effects: {
    // 单日值
    *search_week(_, { put, select, call }) {
      let transferFrequencyNew = yield select(({ transferFrequencyNew }) => transferFrequencyNew);
      const { searchParams, } = transferFrequencyNew;
      const params = {
        startDate: searchParams.dayStartDate,
        areaProperty: searchParams.areaProperty,
        queryType: 1,
      }
      const { code, data } = yield call(getTransitFrequency, params);

      if (code === 1) {
        if (data) {
          const { 全国: header = [], 营运区: area = [], 分拨: location = [] } = data;
          let list = [];
          let weekExpandedRowKeys = [];
          const weekExportList = [...header, ...area, ...location];
          if (header.length > 0 && area.length > 0 && location.length > 0) {
            list = [...header, ...mergeAndStructure(area, location, 'originManageAreaName')];
          } else if ((header.length === 0 || !header) && area.length > 0 && location.length > 0) {
            list = mergeAndStructure(area, location, 'originManageAreaName');
            weekExpandedRowKeys = area.map(item => item.originSite);
          } else {
            list = location;
          }
          yield put({
            type: 'update',
            payload: { weekDatas: list, weekExportList, weekExpandedRowKeys, totalWeek: list?.length || 0 },
          });
        }else{
          yield put({
            type: 'update',
            payload: { weekDatas: [], weekExportList:[], weekExpandedRowKeys:[], totalWeek: 0 },
          });
        }
      }
    },
    // 周累计值
    *search_month(_, { put, select, call }) {
      let transferFrequencyNew = yield select(({ transferFrequencyNew }) => transferFrequencyNew);
      const { searchParams, } = transferFrequencyNew;
      const params = {
        startDate: searchParams.weekStartDate,
        areaProperty: searchParams.areaProperty,
        queryType: 2,
      }
      const { code, data } = yield call(getTransitFrequency, params);

      if (code === 1) {
        if (data) {
          const { 全国: header = [], 营运区: area = [], 分拨: location = [] } = data;
          let list = [];
          let monthExpandedRowKeys = [];
          const monthExportList = [...header, ...area, ...location];
          if (header.length > 0 && area.length > 0 && location.length > 0) {
            list = [...header, ...mergeAndStructure(area, location, 'originManageAreaName')];
          } else if ((header.length === 0 || !header) && area.length > 0 && location.length > 0) {
            list = mergeAndStructure(area, location, 'originManageAreaName');
            monthExpandedRowKeys = area.map(item => item.originSite);
          } else {
            list = location;
          }
          yield put({
            type: 'update',
            payload: { monthDatas: list, monthExportList, monthExpandedRowKeys, totalMonth: list?.length || 0 },
          });
        }else{
          yield put({
            type: 'update',
            payload: { monthDatas: [], monthExportList:[], monthExpandedRowKeys:[], totalMonth:0 },
          });
        }
      }
    },
  },

  reducers: {
    update(state, { payload }) {
      return { ...state, ...payload };
    },
    updateState(state, { payload }) {
      return { ...state, ...payload };
    },
    updateSearchParams(state, { payload }) {
      return { ...state, searchParams: { ...state.searchParams, ...payload } };
    },
  },
};

